import React, { Component, Fragment } from "react";
import "./FlashCard.scss";
import homeIcon from "../../../assets/images/home_icon.png";
import backIcon from "../../../assets/images/back_icon.png";
import nextIcon from "../../../assets/images/next_icon.png";
import randomIcon from "../../../assets/images/button_shuffle_icon.png";
import emptyFrontGraphic from "../../../assets/images/flashcard_questionmark.png";
import ReactCardFlip from "react-card-flip";
import { NavLink } from "react-router-dom";
import $ from "jquery";
import { getFlashcardsDetails } from "../../../actions";
import { connect } from "react-redux";
import LoaderComponent from "../../LoaderComponent";
import ImageLoader from "../../ImageLoader";
import { toArray, random } from "lodash";
import global from "../../../global";

class FlashCard extends Component {
  constructor() {
    super();
    this.state = {
      isFlipped: false,
      selectedFlashcardId: "",
      isLoading: true,
      currentFlashcardId: 1,
      totalFlashcards: 0,
      currentFlashCard: null,
      isFrontImageLoading: true,
      isBackImageLoading: true,
    };
  }

  componentDidMount() {
    const { cookies, match } = this.props;
    const existingCookie = cookies.get("app_settings");
    let diff = "A";
    let qlimit = "0";

    if (existingCookie) {
      if (existingCookie.flashcard_settings.diff) {
        diff = existingCookie.flashcard_settings.diff;
        this.props
          .getFlashcardsDetails(
            "?qsid=" +
              global.config.QSID +
              "&diff=" +
              diff +
              "&qlimit=" +
              qlimit
          )
          .then((res) => {
            this.setState(
              {
                isLoading: false,
                totalFlashcards: toArray(this.props.flashcardsList).length,
              },
              () => {
                if (match.params && match.params._flashcardId) {
                  this.setState(
                    {
                      currentFlashcardId: match.params._flashcardId,
                    },
                    () => {
                      this.showFlashCard();
                    }
                  );
                }
              }
            );
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.props.history.push("/flashcards-difficulty");
      }
    } else {
      this.props.history.push("/flashcards-difficulty");
    }
  }

  handleClick = (e) => {
    e.preventDefault();
    this.setState((prevState) => ({ isFlipped: !prevState.isFlipped }));
  };

  showFlashCard = () => {
    this.props.history.push("/flashcard/" + this.state.currentFlashcardId);
    this.setState(
      {
        currentFlashCard: this.props.flashcardsList[
          parseInt(this.state.currentFlashcardId) - 1
        ],
        isFlipped: false,
        isFrontImageLoading: true,
        isBackImageLoading: true,
      },
      () => {
        this.adjustCardDetails();
      }
    );
  };

  adjustCardDetails = () => {
    if (document.getElementById("front_question_container")) {
      let mainContainerHeight = $("#front_card_container").height();
      let childContainerHeight = $(".question-container").outerHeight();
      let descriptionContainerPadding =
        $(".description-container").outerHeight() -
        $(".description-container").height();

      $(".description-container").css(
        "max-height",
        mainContainerHeight -
          childContainerHeight -
          descriptionContainerPadding +
          "px"
      );
      $(".description-container").animate({ scrollTop: 0 }, "fast");
    }
  };

  onClickNextBtn = () => {
    this.setState(
      (prevState) => {
        return {
          currentFlashcardId:
            parseInt(prevState.currentFlashcardId) >= this.state.totalFlashcards
              ? 1
              : parseInt(prevState.currentFlashcardId) + 1,
        };
      },
      () => {
        this.showFlashCard();
      }
    );
  };

  onClickPrevBtn = () => {
    this.setState(
      (prevState) => ({
        currentFlashcardId:
          parseInt(prevState.currentFlashcardId) <= 1
            ? this.state.totalFlashcards
            : parseInt(prevState.currentFlashcardId) - 1,
      }),
      () => {
        this.showFlashCard();
      }
    );
  };

  getRandomFlashCard = () => {
    let randomId = random(1, this.state.totalFlashcards);
    if (randomId === this.state.currentFlashcardId) {
      this.getRandomFlashCard();
    } else {
      this.setState(
        {
          currentFlashcardId: randomId,
        },
        () => {
          this.showFlashCard();
        }
      );
    }
  };

  imageLoaded = () => {
    //hide image loader
    this.setState({
      isFrontImageLoading: false,
    });
  };

  render() {
    const {
      isLoading,
      currentFlashcardId,
      totalFlashcards,
      currentFlashCard,
      isFrontImageLoading,
      isBackImageLoading,
    } = this.state;
    const { questionSetDetails } = this.props;
    this.adjustCardDetails();

    return (
      <div className="single-flashcard-container">
        {isLoading ? (
          <LoaderComponent loading={isLoading} />
        ) : (
          <React.Fragment>
            <div className="flashcard-header-container">
              <NavLink
                className="home-icon-container"
                // to={`${process.env.PUBLIC_URL}/`}
                to={"/"}
              >
                <img src={homeIcon} alt="home" />
              </NavLink>
              <div
                className={
                  "back-icon-container"
                  // +
                  // (currentFlashcardId <= 1 ? " disabled" : "")
                }
                onClick={this.onClickPrevBtn}
              >
                <img src={backIcon} alt="home" />
              </div>
              <div className="card-count-container">
                {currentFlashcardId} of {totalFlashcards}
              </div>
              <div
                className={
                  "next-icon-container"
                  // +
                  // (currentFlashcardId >= totalFlashcards ? " disabled" : "")
                }
                onClick={this.onClickNextBtn}
              >
                <img src={nextIcon} alt="next" />
              </div>
              <div
                className={
                  "random-icon-container" +
                  (totalFlashcards <= 1 ? " disabled" : "")
                }
                onClick={this.getRandomFlashCard}
              >
                <img src={randomIcon} alt="random" />
              </div>
            </div>
            <div className="flashcard-data-container">
              {currentFlashCard && (
                <div className="single-flashcard">
                  <ReactCardFlip
                    isFlipped={this.state.isFlipped}
                    flipDirection="horizontal"
                  >
                    <div
                      className="card-front-side"
                      id="front_card_container"
                      onClick={this.handleClick}
                    >
                      <div
                        className="question-container"
                        id="front_question_container"
                      >
                        {currentFlashCard.QFlashcard}
                      </div>
                      <div
                        className="description-container centered-content"
                        id="front_description_container"
                      >
                        {currentFlashCard.FrontGraphicURL ? (
                          <div className="question-graphic-container">
                            <div
                              style={{
                                display: isFrontImageLoading ? "block" : "none",
                              }}
                            >
                              <ImageLoader />
                            </div>
                            <img
                              src={
                                questionSetDetails.QSResourcePath +
                                currentFlashCard.FrontGraphicURL
                              }
                              alt="question-graphic"
                              onLoad={() => {
                                this.setState({ isFrontImageLoading: false });
                              }}
                              style={{
                                display: isFrontImageLoading ? "none" : "block",
                              }}
                            />
                          </div>
                        ) : (
                          <div className="question-graphic-container">
                            <img
                              src={emptyFrontGraphic}
                              alt="question-graphic"
                              className="question-graphic-blank"
                            />
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="card-back-side" onClick={this.handleClick}>
                      <div className="question-container">
                        {currentFlashCard.QFlashcard}
                      </div>
                      <div
                        className="description-container"
                        id="back_description_container"
                      >
                        <div className="answer-container">
                          {currentFlashCard.AFlashcardAnswer && (
                            <div className="answer-title-container">
                              {currentFlashCard.AFlashcardAnswer}
                            </div>
                          )}
                          {currentFlashCard.AFlashcardDetails.split("\n").map(
                            (item, key) => {
                              return (
                                <Fragment key={key}>
                                  {item}
                                  <br />
                                </Fragment>
                              );
                            }
                          )}
                          {currentFlashCard.BackGraphicURL && (
                            <div className="answer-graphic-container">
                              <div
                                style={{
                                  display: isBackImageLoading
                                    ? "block"
                                    : "none",
                                  padding: "15px",
                                }}
                              >
                                <ImageLoader />
                              </div>
                              <img
                                src={
                                  questionSetDetails.QSResourcePath +
                                  currentFlashCard.BackGraphicURL
                                }
                                alt="answer-graphic"
                                onLoad={() => {
                                  this.setState({
                                    isBackImageLoading: false,
                                  });
                                }}
                                style={{
                                  display: isBackImageLoading
                                    ? "none"
                                    : "block",
                                }}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </ReactCardFlip>
                </div>
              )}
            </div>
          </React.Fragment>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    flashcardsList: state.flashcardsList,
    questionSetDetails: state.questionSetDetails,
  };
};

export default connect(mapStateToProps, {
  getFlashcardsDetails,
})(FlashCard);
